// Based on focus trap by W3C WAI
// @see https://www.w3.org/WAI/ARIA/apg/example-index/dialog-modal/js/dialog.js
/**
 * @description Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns {boolean}
 *  true if a focusable element is found and focus is set.
 */
const focusFirstDescendant = function (element) {
  for (let i = 0; i < element.childNodes.length; i++) {
    let child = element.childNodes[i];
    if (
      attemptFocus(child) ||
      focusFirstDescendant(child)
    ) {
      return true;
    }
  }
  return false;
};

/**
 * @description Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns {boolean}
 *  true if a focusable element is found and focus is set.
 */
const focusLastDescendant = function (element) {
  for (let i = element.childNodes.length - 1; i >= 0; i--) {
    let child = element.childNodes[i];
    if (
      attemptFocus(child) ||
      focusLastDescendant(child)
    ) {
      return true;
    }
  }
  return false;
};

/**
   * @description Set Attempt to set focus on the current node.
   * @param element
   *          The node to attempt to focus on.
   * @returns {boolean}
   *  true if element is focused.
   */
const attemptFocus = function (element) {
  if (!isFocusable(element)) {
    return false;
  }

  try {
    element.focus();
  } catch (e) {
    // continue regardless of error
  }

  return document.activeElement === element;
};

const isFocusable = function (element) {
  if (element.tabIndex < 0) {
    return false;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
  case 'A':
    return element.rel != 'ignore';
  case 'INPUT':
    return element.type != 'hidden';
  case 'BUTTON':
  case 'SELECT':
  case 'TEXTAREA':
    return true;
  default:
    return false;
  }
};

export const setFocusTrap = (parent) => {
  // Trap focus
  const preDiv = document.createElement('div');
  preDiv.dataset.focusTrap = '';
  preDiv.tabIndex = 0;
  preDiv.addEventListener('focus', () => {
    focusLastDescendant(parent);
  })
  parent.insertAdjacentElement('afterbegin', preDiv);

  const postDiv = document.createElement('div');
  postDiv.dataset.focusTrap = '';
  postDiv.tabIndex = 0;
  postDiv.addEventListener('focus', () => {
    focusFirstDescendant(parent);
  })
  parent.insertAdjacentElement('beforeend', postDiv);
}

export const removeFocusTrap = (parent) => {
  const traps = parent.querySelectorAll('[data-focus-trap]');
  for (let index = 0; index < traps.length; index++) {
    const trap = traps[index];
    trap.remove();
  }
}
